const PartnersTerritoriesListMock = {
  message: "OK",
  responseData: {
    territories: ["Parner", "Aurangabad", "Soegaon"],
  },
  status: true,
};

export default PartnersTerritoriesListMock;
